module.exports = __webpack_public_path__ + "img/logo.7465e661.svg";